'use strict';

angular.module('forgot')

.config(function ($stateProvider)
{
    $stateProvider
        .state('app.forgot', {
            url: '/forgot',
            templateUrl: 'modules/forgot/forgot.html'
        });
});
